export const iconFontAwesomeTravelHotelPlaneSlash = (
	<i className="fa-solid fa-plane-slash"></i>
);
